import React from "react";
import "../component/supplierTable.css";

const SupplierTable = ({
  page,
  suppliers,
  onEditSupplierClicked,
  onDeleteSupplierClicked,
}) => {
  const editSupplier = (supplier) => {
    onEditSupplierClicked(supplier);
  };

  const deleteSupplier = (supplier) => {
    onDeleteSupplierClicked(supplier);
  };

  return (
    <div className="supplier-table-container">
      <table className="supplier-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Supplier</th>
            <th>Alamat Supplier</th>
            <th>Kota Supplier</th>
            <th>No Telpon Supplier</th>
            <th>Status Pajak</th>
            <th>Tipe Transaksi</th>
            <th>Supplier NPWP</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {suppliers.length > 0 ? (
            suppliers.map((supplier, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{supplier.supplier_name}</td>
                <td>{supplier.supplier_address}</td>
                <td>{supplier.supplier_city}</td>
                <td>{supplier.supplier_phone_number}</td>
                <td>{supplier.supplier_tax_status}</td>
                <td>{supplier.supplier_transaction_type}</td>
                <td>{supplier.supplier_NPWP}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editSupplier(supplier);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteSupplier(supplier);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SupplierTable;
